import type { IPaginationOptions, ISortOptions } from "types/pagination";

import type { TQsFilter } from "./pagination";

export interface IPaginatedSearchOptions {
  filters?: TQsFilter;
  pagination?: IPaginationOptions;
  search?: ISearchOptions;
  sort?: ISortOptions;
}

interface ISearchOptions {
  query?: string;
}

export const getPaginatedSearchQueryString = (options?: IPaginatedSearchOptions) => {
  let qsFields: [string, number | string][] = [];
  if (!options) {
    return "";
  }

  const { pagination, search, sort } = options;
  if (search && search.query) {
    // Need to change this field in main-api
    qsFields.push(["search", encodeURIComponent(search.query)]);
  }

  if (pagination && pagination.perPage) {
    qsFields.push(["perPage", pagination.perPage]);
    if (pagination.page) qsFields.push(["page", pagination.page]);
  }

  if (sort) {
    if (sort?.order) qsFields.push(["sortOrder", sort.order]);
    if (sort?.sortFields) {
      const addedFields =
        typeof sort.sortFields === "string"
          ? [["sortFields", sort.sortFields] as [string, string]]
          : sort.sortFields.map((field) => ["sortFields", field] as [string, string]);
      qsFields = qsFields.concat(addedFields);
    }
  }

  const filtersQs = options.filters && options.filters.toQueryString ? `&${options.filters.toQueryString()}` : "";
  const qs = qsFields.map(([key, value]) => `${key}=${value}`).join("&");

  return qs + (qs && filtersQs ? "&" + filtersQs : "");
};
